export async function normalizeErrorHandling (response) {
  if (!response.ok) {
    response.parsedText = await response.text()
    return Promise.reject(response)
  }

  return response
}
